import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";
import { layoutUsesFullWidth } from "./layoutWidth";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const location = useLocation();
  // Wide workspaces (layoutWidth.ts): the usual content column would waste
  // most of the screen.
  const usesFullWidth = layoutUsesFullWidth(location.pathname);

  return (
    <>
      <Header />
      <main
        className={cn(
          "mx-auto w-full px-4 pt-4",
          usesFullWidth ? "max-w-none" : "max-w-screen-xl",
        )}
        data-layout-width={usesFullWidth ? "full" : "contained"}
        id="main-content"
      >
        <ErrorBoundary FallbackComponent={Error}>
          <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
            {children}
          </Suspense>
        </ErrorBoundary>
      </main>
      <Notification />
    </>
  );
};
